import { Injectable } from '@angular/core';
import { Observable, of, delay } from 'rxjs';
import ApiOptionsConfig from '../api-options.config';
import { ApiBaseService } from '../api-base.service';

const BASE_URL = '/jurisdictions';
const BASE_URL_LANGUAGES = '/features/languages/JURISDICTION';

@Injectable({
  providedIn: 'root'
})
export class JurisdictionsService extends ApiBaseService {

  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  detail(jurisdictionId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${jurisdictionId}`), options?.params);
  }

  create(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL), data);
  }

  update(jurisdictionId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${jurisdictionId}`), data);
  }

  delete(jurisdictionId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${jurisdictionId}`));
  }

  languages(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL_LANGUAGES), options?.params);
  }
}
